export function formatZip(value: string): string {
  const digits = value.replace(/\D/g, "").slice(0, 9)
  if (digits.length <= 5) return digits
  return `${digits.slice(0, 5)}-${digits.slice(5)}`
}

export function isValidZip(value: string): boolean {
  return /^\d{5}(-\d{4})?$/.test(value)
}
